<template>
  <el-menu
    :default-active="activeIndex"
    @select="handleSelect"
    background-color="#333333"
      text-color="#8253A8"
      active-text-color="#ffffff"
    style="height: 100vh;"
  >

    <el-menu-item index="home" style="font-size: large;font-weight: bold; color: white;">幻想游戏</el-menu-item>

    <el-menu-item index="article">文章</el-menu-item>
    <el-menu-item index="game">游戏</el-menu-item>
    <el-menu-item index="material" v-if="userInfo && userInfo.isadmin==1">素材</el-menu-item>
    <!-- <el-menu-item index="ad">我的广告</el-menu-item>
    <el-menu-item index="bidding">广告竞价</el-menu-item> -->
    <el-menu-item index="logout">退出</el-menu-item>

    <el-menu-item index="test" v-if="userInfo && userInfo.isadmin==1">测试</el-menu-item>

  </el-menu>
</template>

<script>
import { MyStorage } from '@/common.js';
export default {
  data() {
    return {
      userName: "未登录",
      userInfo:null,
      test: process.env.VUE_APP_API_URL,
      activeIndex: "game",
      urlList: {
        article:'/article',
        game:'/game',
        material:'/material',
        ad:'/ad',
        bidding:'/bidding',
        test:'/test',
      }
    };
  },
  mounted() {
    this.activeIndex=window.location.hash.substring(2)
    console.log(JSON.parse(MyStorage.getItem("userInfo")));
    if (MyStorage.getItem("userInfo")) {
      this.userInfo=JSON.parse(MyStorage.getItem("userInfo"))
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (key === "logout") {
        this.api.logout(
          res => {
            MyStorage.removeItem("userInfo");
            MyStorage.removeItem("api_token");
            MyStorage.removeItem("expiration");
          },
          err => {}
        );
        this.$router.push("/login");
        return;
      }
      if (!this.urlList[key]) return;
      this.$router.push(this.urlList[key]);
    }
  }
};
</script>

<style>
    .el-menu{
        border-right: none !important;
    }
</style>
